import { render } from "./BatchEditor.vue?vue&type=template&id=135638dc&scoped=true"
import script from "./BatchEditor.vue?vue&type=script&lang=js"
export * from "./BatchEditor.vue?vue&type=script&lang=js"

import "./BatchEditor.vue?vue&type=style&index=0&id=135638dc&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135638dc"]])

export default __exports__